import { AiOutlineMail, AiOutlinePhone } from "react-icons/ai";
import { BiMap } from "react-icons/bi";
import { v4 as uuidv4 } from "uuid";

const WidgetGetinTouchData = [
  {
    id: uuidv4(),
    icon: <AiOutlinePhone />,
    heading: "Phone Number",
    text: "+91 7620108513",
  },

  {
    id: uuidv4(),
    icon: <AiOutlineMail />,
    heading: "Email",
    text: "info@vedanttechnology.com",
  },

  {
    id: uuidv4(),
    icon: <BiMap />,
    heading: "Location",
    text: "Sanalp Business Center, Sambhajinagar, MH",
  },
];

export default WidgetGetinTouchData;
